module.exports = __webpack_public_path__ + "static/media/logo-full.46a27b51.svg";